import { Component, OnInit, Input, ViewChild, OnChanges, SimpleChanges, TemplateRef } from '@angular/core';
import { ProgramService } from 'app/client-core/services/program.service';
import { Observable, Subscription } from 'rxjs';
import { ValidationMessage } from 'app/validation';
import { PaginationInfo } from 'app/client-core/api-response-models';
import { Router } from '@angular/router';
import { CampaignThemeDto } from 'app/client-core/dtos/campaigns.model';
import { CampaignService } from 'app/client-core/services/campaign.service';
import { LayoutService } from '../layout/layout.service';
import { UserService } from 'app/client-core/services/user.service';
import { NotificationService } from '../utils/notification.service';
import { AppDatatableCellTypes, AppDatatableConfigOptions } from '../datatable';
import { ProgramTacticDto, ProgramTacticId } from 'app/client-core/dtos/tactics.model';
import { TacticService } from 'app/client-core/services/tactic.service';
import { SiteConfigurationValuePipe } from '../pipes/site-configuration-value.pipe';
import { ProgramDto, ProgramId } from 'app/client-core/dtos/programs.model';

const $ = jQuery;
@Component({
  selector: 'app-campaign-cart-modal',
  templateUrl: './campaign-cart-modal.component.html',
  styleUrls: ['./campaign-cart-modal.component.scss']
})
export class CreateCampaignCartModalComponent implements OnInit, OnChanges {

  ready: boolean;
  loading: boolean = true;

  @ViewChild('idCellTemplate')
  private idCellTemplate: TemplateRef<any>;

  @ViewChild('nameCellTemplate')
  private nameCellTemplate: TemplateRef<any>;

  @ViewChild('actionCellTemplate')
  private actionCellTemplate: TemplateRef<any>;

  @ViewChild('quantitySummaryCellTemplate')
  private quantitySummaryCellTemplate: TemplateRef<any>;

  // this is assigned by the opener if it is an edit
  @Input() selectedProgramId: number;
  @Input() canSubmit: number;
  @Input() canApprove: number;
  @Input() canSaveAll: boolean;
  @Input() showApproveAndSubmitButtons: boolean;
  @Input() fromCustomizations: boolean;

  cartTotal: number;
  columns: Observable<Array<any>>;
  rows: Array<{ tactics: Array<ProgramTacticDto>, deliveryMethodId: number, deliveryMethodName: string }>;
  totalItems: number;
  paginationInfo: Observable<PaginationInfo>;
  config: Observable<AppDatatableConfigOptions>;
  pageSize: number;
  pageSizeOptions: Array<number>;
  public validationMessages: ValidationMessage;
  @Input() canGoToNextStep = true;
  programTacticSavedSubscription: Subscription;
  hideNextSteps: boolean;
  siteConfigValuePipe: SiteConfigurationValuePipe;
  campaignDto: CampaignThemeDto = {} as CampaignThemeDto;
  programDto: ProgramDto = {} as ProgramDto;
  campaignLoaded: boolean;

  constructor(
    private tacticService: TacticService,
    private notificationService: NotificationService,
    private programService: ProgramService,
    private router: Router,
    private userService: UserService,
    private layoutService: LayoutService,
    private campaignService: CampaignService,
  ) {
    this.siteConfigValuePipe = new SiteConfigurationValuePipe(userService);
  }

  ngOnInit() {
    this.fromCustomizations = location.href.indexOf('/customize') > -1;
    this.pageSize = 50;
    this.pageSizeOptions = [25, 50, 100, 150];
  }

  loadComponent() {
    if (this.programTacticSavedSubscription) {
      this.programTacticSavedSubscription.unsubscribe();
    }

    this.loadProgramTactics();
    this.programTacticSavedSubscription = this.tacticService.programTacticSaved.subscribe((id: ProgramId) => {
      this.loadProgramTactics();
    });
  }

  loadProgramAndCampaign() {
    this.programService.getProgram(this.selectedProgramId).subscribe(res => {
      if (res.data && !res.hasError) {
        this.programDto = res.data;

        if (this.programDto.campaignThemeId) {
          this.campaignService.getCampaignTheme(this.programDto.campaignThemeId).subscribe(c => {
            if (c.data && !c.hasError) {
              this.campaignDto = c.data;
              this.loadComponent();
            }
          });
        } else {
          this.loadComponent();
        }
      }
    })
  }

  clear() {
    return new Promise((resolve, reject) => {
      this.programDto = {} as ProgramDto;
      this.campaignDto = {} as CampaignThemeDto;
      this.loading = true;
      resolve(true);
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  closeModal() {
    this.clear();
    this.layoutService.hideSideModal.next();
  }

  changeTheme() {
    if (this.selectedProgramId) {
      this.router.navigateByUrl(`/campaign-library/${this.selectedProgramId}`);
    }
  }

  goToSelectCampaign() {
    this.router.navigateByUrl(`/campaign-library/${this.selectedProgramId}`);
  }

  openTactic(tactic: ProgramTacticDto): void {
    if (tactic.tacticProductTypeId == 2 || tactic.tacticProductTypeId == 3 || tactic.tacticProductTypeId == 5) {
      this.tacticService.editProgramTactic.next(new ProgramTacticId(tactic.id));
    } else if (tactic.tacticProductTypeId == 4) {
      this.tacticService.editNewProgramTactic.next(new ProgramTacticId(tactic.id));
    }
  }

  private loadProgramTactics(event: any = {}): void {
    this.ready = false;
    this.tacticService.getCartProgramTactics(this.selectedProgramId)
      .subscribe(res => {
        if (!res.hasError) {
          this.rows = res.data.filter(r => r.tactics && r.tactics.length > 0);
          let items = [];
          res.data.map(g => {
            items = items.concat(g.tactics)
          })

          this.cartTotal = items.reduce(function (accumulator, currentValue) {
            return accumulator + currentValue.totalAtlBtlCost;
          }, 0);

          this.ready = true;
          this.loading = false;
        } else {
          this.validationMessages = new ValidationMessage(res.error, true, "Data could not be retrieved");
        }
      },
        (err: any) => {
          this.validationMessages = new ValidationMessage(null, true, "Unexpected error occured");
        },
        () => {
          this.ready = false;
        });
  }

  onRowSelect(event: any): void {
    console.log(">>> onRowSelect", event);
  }

  onRowActivate(event: any): void {
    //console.log(">> onRowActivate", event);
  }

  onTableAction(event: any): void {
    console.log(">>> onTableAction", event);
    this.loadProgramTactics(Object.assign(event, { programId: this.selectedProgramId }));
  }

  tableActionDone(event: any): void {
    console.log(">>> onTableActionDone", event);
  }

  goNextStepFromCustomizations() {
    this.router.navigate([`tactic-catalog/${this.selectedProgramId}/finalize`]);
    this.closeModal();
  }

  goNextStep() {
    this.closeModal();
    if (this.programDto.campaignThemeTypeId == 4) {
      this.router.navigate([`tactic-catalog/${this.selectedProgramId}/customize/2`]);
      return;
    }
    this.tacticService.biTacticNextStepRequested.next();
  }

  delete(programTacticId, programId) {
    try {

      this.notificationService.smartMessageBox({
        title: "<i class='fa fa-trash text-danger'></i> Are you sure you want to delete this Program Tactic?",
        content: "Please confirm.",
        buttons: '[Cancel][Yes]'

      }, (ButtonPressed, Value) => {
        if (ButtonPressed == "Yes") {
          this.tacticService.deleteProgramTactic(programTacticId)
            .subscribe(res => {
              if (!res.hasError) {
                this.validationMessages = new ValidationMessage(null, true, "Program Tactic removed")
                  .pushMessage("Successfully removed from your cart")
                  .isSuccess();
                this.tacticService.programTacticSaved.next(new ProgramId(programId));
              } else {
                this.validationMessages = new ValidationMessage(res.error, true, "Program Tactic could not be removed");
              }
            },
              (err: any) => {
                this.validationMessages = new ValidationMessage(null, true, "Unexpected error occured");
              },
              () => {
                //this.loading = false;
              });
        }
      });
    } catch (e) {
      //this is to stop closing the box
    }
  }

  submitFinalization() {
    this.closeModal();
    $('tactics-catalog-finalize .save-and-submit').trigger('click');
  }

  approveFinalization() {
    this.closeModal();
    $('tactics-catalog-finalize .approve-button').trigger('click');
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/campaign-cart-modal/campaign-cart-modal.component.ts